import styled from 'styled-components';
import { colors, fontWeights, spacing, Subtitle1 } from 'ui/theme';
import { AffinityCardsFlexResponsiveContainer } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/common.styles';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import {
  ABOUT_YOUR_COHORT_USERS_TEXTS,
  descriptionsByCohort,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { useBrandAffinityTranslation, BRAND_AFFINITY_NAMES_TO_I18N_KEYS } from 'modules/domains';
import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { SPACING_SIZE } from 'ui/flexSpacer/constants';
import { TopTooltip } from 'ui/tooltip';

const CohortHeader = styled(Subtitle1)`
  font-weight: ${fontWeights.semiBold};
  margin: 0;
`;

const MarginFlexSpacer = styled(FlexSpacer)`
  margin: ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.base} ${spacing.plusHalf};
`;

const LightColoredToolTip = styled(TopTooltip)`
  text-decoration-color: ${colors.borderEmphasis};
`;

export const ABOUT_YOUR_COHORT_USERS_ID = 'about-your-cohort-users';

export const AboutYourCohortCards = ({ children }: React.PropsWithChildren<unknown>) => {
  const { t } = useBrandAffinityTranslation();
  const { selectedAffinityTab } = useCoreContext();
  const cohortText = descriptionsByCohort[selectedAffinityTab] || '';
  return (
    <>
      <MarginFlexSpacer alignItems="center" gap={SPACING_SIZE.quarter}>
        <CohortHeader>{ABOUT_YOUR_COHORT_USERS_TEXTS.ABOUT_YOUR}</CohortHeader>
        <LightColoredToolTip isUnderlined tooltipContent={cohortText}>
          <CohortHeader data-test={`${ABOUT_YOUR_COHORT_USERS_ID}-${selectedAffinityTab}`}>
            {t(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[selectedAffinityTab])}
          </CohortHeader>
        </LightColoredToolTip>
        <CohortHeader>{ABOUT_YOUR_COHORT_USERS_TEXTS.USERS}</CohortHeader>
      </MarginFlexSpacer>
      <AffinityCardsFlexResponsiveContainer>{children}</AffinityCardsFlexResponsiveContainer>
    </>
  );
};
